import Page from 'modules/app/components/Page';
import ProfileMenuHeader from 'modules/app/components/ProfileMenu/ProfileMenuHeader';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import s from './SalonFilterPage.module.scss';
import useGetAllSalons from 'sdk/hooks/salon/useGetAllSalons';
import useGetAllProducts from 'sdk/hooks/shop/useGetAllProducts';
import useGetAllBrands from 'sdk/hooks/shop/useGetAllBrands';
import Selector from './Selector';
import PriceRange from './PriceRange';
import Switcher from './Switcher';
import SelectableButtons from './SelectableButtons';
import { useTranslation } from 'react-i18next';

const mapToOptions = (data) =>
    data?.map((item) => ({
        label: item?.name,
        value: item?.id,
    }));

const SalonFilterPage = () => {
    const {t} = useTranslation()
    const navigate = useNavigate();
    const { data: services } = useGetAllSalons();
    const { data: products } = useGetAllProducts();
    const { data: brands } = useGetAllBrands();


    const options = [
        { name: 'Services', placeholder: 'Select service', data: services },
        { name: 'Product', placeholder: 'Select product', data: products },
        { name: 'Brand', placeholder: 'Select brand', data: brands },
    ];

    return (
        <div className={s.container}>
            <Page activeLink="/venues">
                <ProfileMenuHeader onClose={() => navigate(-1)} text={'Filters'} />
                <div className={s.filters}>
                    {options.map(({ name, placeholder, data }) => (
                        <Selector
                            key={name}
                            name={name}
                            placeholder={placeholder}
                            options={mapToOptions(data)}
                        />
                    ))}
                    <div className={s.selector_left}>Price range</div>
                    <PriceRange />
                    <Switcher />
                    <SelectableButtons />
                </div>
            </Page>
        </div>
    );
};

export default SalonFilterPage;
